export default __webpack_public_path__ + "static/media/FORVAL_TECHNOLOGY_logo.ca18616d.svg";